import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Code:")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Name:")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Currency:")
], -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "col-md-9" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Legal Parent:")
], -1)
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "col-md-9" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "col-md-9" }
const _hoisted_34 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Status:")
], -1)
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "row mb-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Is Virtual: ")
], -1)
const _hoisted_39 = { class: "col-md-6 pt-1" }
const _hoisted_40 = { class: "row mb-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_42 = { class: "d-flex col-md-6" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    onDeleteEvent: _ctx.deleteCompany,
                    renderDelete: (_ctx.identifier != null ? true : false),
                    isDeleting: _ctx.isDeleting,
                    isDeleteValidate: _ctx.isDeleteValidate
                  }, null, 8, ["onDeleteEvent", "renderDelete", "isDeleting", "isDeleteValidate"]),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_InputText, {
                                class: "p-inputtext",
                                type: "text",
                                maxlength: "10",
                                placeholder: "Code",
                                modelValue: _ctx.company.code,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company.code) = $event)),
                                readonly: _ctx.identifier != null
                              }, null, 8, ["modelValue", "readonly"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_InputText, {
                                class: "p-inputtext",
                                type: "text",
                                maxlength: "100",
                                placeholder: "Name",
                                modelValue: _ctx.company.name,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company.name) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.currencies,
                                optionLabel: "code",
                                optionValue: "identifier",
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                placeholder: "-- Please Select --",
                                modelValue: _ctx.company.currency.identifier,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company.currency.identifier) = $event))
                              }, {
                                value: _withCtx((slotProps) => [
                                  (slotProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.filterCurrencyCodeByValue(slotProps.value)), 1),
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.filterCurrencyNameByValue(slotProps.value)), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(slotProps.placeholder), 1))
                                ]),
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(slotProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(slotProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["options", "modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.companies,
                                optionLabel: "code",
                                optionValue: "identifier",
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                placeholder: _ctx.isCompanyLoading ? ('Loading...') : '-- Please Select --',
                                loading: _ctx.isCompanyLoading,
                                modelValue: _ctx.company.companyId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.company.companyId) = $event))
                              }, {
                                value: _withCtx((slotProps) => [
                                  (slotProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.filterCompanyCodeByValue(slotProps.value)), 1),
                                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.filterCompanyNameByValue(slotProps.value)), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(slotProps.placeholder), 1))
                                ]),
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(slotProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(slotProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["options", "placeholder", "loading", "modelValue"])
                            ])
                          ]),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _hoisted_35,
                                _createElementVNode("div", _hoisted_36, [
                                  _createVNode(_component_Dropdown, {
                                    options: _ctx.getActiveStatuses(_ctx.statuses),
                                    optionLabel: "name",
                                    optionValue: "value",
                                    placeholder: "-- Please Select --",
                                    modelValue: _ctx.company.isClosed,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company.isClosed) = $event))
                                  }, null, 8, ["options", "modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_Checkbox, {
                                modelValue: _ctx.company.isVirtual,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.company.isVirtual) = $event)),
                                binary: true
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_Button, {
                                class: "p-button-sm",
                                disabled: _ctx.v$.company.$invalid || _ctx.isLoading,
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.identifier == null ? _ctx.save() : _ctx.update())),
                                label: "Save"
                              }, null, 8, ["disabled"]),
                              _hoisted_43,
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.cancel,
                                label: "Cancel"
                              }, null, 8, ["onClick"]),
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}